import { o_global } from "../../common/namespaces";
import type { EventLoaderEvents } from "./index.js";
import { store, type ListenerContainer } from "./store.js";
import type { QBus } from "../event-q-bus/index.js";

/**
 *
 *
 *
 *
 *
 *
 */
export const sortByPriority = <T extends { priority: number }>(queue: T[]): T[] =>
  queue.sort((a, b) => a.priority - b.priority);

export const invokeListener =
  <A>(ev: A): ((listener: ListenerContainer) => void) =>
  (handler) => {
    try {
      handler.fn(ev as never);
    } /*                  */ catch (e) {
      Promise.resolve().then(() => {
        throw e;
      });
    }
  };

/**
 *
 */
export function handleOnReady(ev: Event): void {
  store.onReadyEvent = ev || {};
  store.onReadyQueue = sortByPriority(store.onReadyQueue);
  store.onReadyQueue.forEach(invokeListener(store.onReadyEvent));

  /*                                      */
  (window.o_global.eventQBus as QBus<EventLoaderEvents> | undefined)?.emitRetain(
    "assets.events.documentReady",
    ev,
  );
}

/**
 *
 */
export const initOnReady = (): void =>
  document.addEventListener("DOMContentLoaded", handleOnReady, false);

/**
 *
 *
 */
export function handleAllJavascriptLoaded(): void {
  store.allJavascriptLoadedComplete = store.onLoadFired && store.allPreloadScriptsLoadedFired;

  if (store.allJavascriptLoadedComplete) {
    store.allJavascriptLoadedQueue = sortByPriority(store.allJavascriptLoadedQueue);
    store.allJavascriptLoadedQueue.forEach((c) => c.fn({} as Event));
  }

  if (store.allJavascriptLoadedComplete && !store.allJavascriptLoadedFired) {
    /*                                      */
    /*                   */
    (o_global.eventQBus as QBus<EventLoaderEvents> | undefined)?.emitRetain(
      "assets.events.allJavascriptLoaded",
    );
    store.allJavascriptLoadedEvent = true;
  }
}

/**
 *
 *
 */
let oldOnLoadFunction:
  | (((this: GlobalEventHandlers, ev: Event) => void) & ((this: Window, ev: Event) => void))
  | null;

/**
 *
 */
/*                                                          */
export function handleOnLoad(this: any, ev: Event): any {
  if (oldOnLoadFunction) {
    oldOnLoadFunction.call(this, ev);
  }

  store.onLoadEvent = ev || {};
  store.onLoadQueue = sortByPriority(store.onLoadQueue);
  store.onLoadQueue.forEach(invokeListener(store.onLoadEvent));

  handleAllJavascriptLoaded();

  /*                                      */
  (o_global.eventQBus as QBus<EventLoaderEvents> | undefined)?.emitRetain(
    "assets.events.windowLoad",
    ev,
  );
}

/**
 *
 *
 */
export function initOnLoad(): void {
  oldOnLoadFunction = window.onload;
  window.onload = handleOnLoad;
}

export function handleAllPreloadScriptsLoaded(ev: Event): void {
  store.allPreloadScriptsLoadedEvent = ev || {};
  store.allPreloadScriptsLoadedQueue = sortByPriority(store.allPreloadScriptsLoadedQueue);
  store.allPreloadScriptsLoadedQueue.forEach(invokeListener(store.allPreloadScriptsLoadedEvent));

  handleAllJavascriptLoaded();

  /*                                                                                  */
  /*                                                                        */
}

/**
 *
 *
 */
export const initAllPreloadScriptsLoaded = (): void =>
  /*                                                 */ document.addEventListener(
    "AllScriptsExecuted",
    handleAllPreloadScriptsLoaded,
    false,
  );
